import { useStripe } from "@stripe/react-stripe-js";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";

type ConfirmCardPaymentResult = {
  ok: boolean;
  paymentIntentStatus?: string;
  errorMessage?: string;
};

export default function useConfirmCardPayment(
) {
  const stripe = useStripe();

  const confirmCardPayment = async (
    clientSecret?: string | null,
  ): Promise<ConfirmCardPaymentResult> => {
    const toastId = "confirm-card-payment";

    Toast({
      message: "Płatność w trakcie przetwarzania.",
      type: TOAST_TYPES_ENUM.LOADING,
      id: toastId,
    });

    if (!clientSecret) {
      const errorMessage = "Błąd przetwarzania płatności.";
      Toast({ message: errorMessage, type: TOAST_TYPES_ENUM.ERROR, id: toastId });
      return { ok: false, errorMessage };
    }

    if (!stripe) {
      const errorMessage = "Stripe nie jest jeszcze gotowy. Spróbuj ponownie za chwilę.";
      Toast({ message: errorMessage, type: TOAST_TYPES_ENUM.ERROR, id: toastId });
      return { ok: false, errorMessage };
    }

    const result = await stripe.confirmCardPayment(clientSecret);
    const error = result.error;
    const paymentIntent = (result as any).paymentIntent as
      | { status?: string }
      | undefined;

    if (error) {
      const errorMessage = "Błąd przetwarzania płatności.";
      Toast({ message: errorMessage, type: TOAST_TYPES_ENUM.ERROR, id: toastId });
      return {
        ok: false,
        errorMessage,
      };
    }

    const status = paymentIntent?.status;
    const isSuccess = status === "succeeded" || status === "processing";

    if (!isSuccess) {
      const errorMessage = "Błąd przetwarzania płatności.";
      Toast({ message: errorMessage, type: TOAST_TYPES_ENUM.ERROR, id: toastId });
      return { ok: false, paymentIntentStatus: status, errorMessage };
    }

    Toast({
      message: "Płatność pobrana.",
      type: TOAST_TYPES_ENUM.SUCCESS,
      id: toastId,
    });

    return { ok: true, paymentIntentStatus: status };
  };

  return { confirmCardPayment };
}
